import React from "react";
import styled from "styled-components";
import { NavLink } from 'react-router-dom'
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import { Home } from 'react-feather'

const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  background: #86B0D8;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-100%)")};
  height: 100vh;
  width: 300px;
  text-align: center;
  padding: 50px 2rem 2rem 2rem; 
  position: fixed; 
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
  z-index: 1000; 
  overflow-y: auto;

  @media (max-width: 576px) {
    width: 100%;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center; 
    gap: 10px; 
  }

  .nav-item {
    width: 100%;
    max-width: 280px;
  }

  /* Testo Nero e Maiuscolo senza toccare i bordi Bootstrap */
  .buttonSide {
    width: 100%;
    display: block;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 0.1rem;
  }

  /* Testo NERO per bottoni azzurri (outline) e gialli (warning) */
  .btn-outline-primary, .btn-warning {
    color: #000000 !important;
  }

  /* Testo BIANCO per il bottone verde (success) */
  .btn-success {
    color: #ffffff !important;
  }

  .nav-item .active.btn-outline-primary:not(.btn-success):not(.btn-warning) {
    color: #ffffff !important;
    border-color: #c9d8f8;
  }
`;

const Menu = ({ open, setOpen }) => {

  return (
    <StyledMenu open={open}>
      <ul className={`navbar-nav mr-auto`} onClick={() => setOpen(false)}>
        <li className={`nav-item active pt-5`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/"><Home size={24}/></NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/alpago">Alpago</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/cadore">Cadore/Comelico</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/oltrepiave">Oltre Piave</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/pale">Pale di San Martino</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/zoldano">Zoldano/Agordino</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/bellunesi">Dolomiti Bellunesi</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/fassa">Fassa/Badia/Gardena</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/brenta">Dolomiti di Brenta</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/giulie">Giulie e Carniche</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-outline-primary'} ${'buttonSide'}`} to="/varie">Varie</NavLink>
        </li><p className="border-bottom pt-3"></p>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-success'} ${'buttonSide'}`} to="/legenda">Legenda Difficoltà</NavLink>
        </li>
        <li className={`nav-item active`}>
          <NavLink className={`${'btn'} ${'btn-warning'} ${'buttonSide'}`} to="/book">Il Libro</NavLink>
        </li>
      </ul>
    </StyledMenu>
  )
}

export default Menu
